<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết yêu cầu thay đổi thông tin</h1>
      <div class="btn-group float-right">
        <button
          class="btn btn-primary"
          v-if="
            dataPermission && dataPermission?.includes('SCON_IN4CHANGE_CHANGE_STATUS_MC_CONFIRM')
          "
          @click="openStatusChangeModal()"
        >
          Chuyển trạng thái MC xác nhận
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>1. Thông tin merchant</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Email MC<span class="float-right">:</span></label
              >
              <div class="col-sm-8" @click="linkMC(item.rootCusId)">
                <p class="form-control-plaintext link f12">{{ item.rootEmail | checkEmpty }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.rootMerchantName | checkEmpty }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.rootAddress | checkEmpty }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.rootMerchantMobile | checkEmpty }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã hợp đồng<span class="float-right">:</span></label
              >
              <div class="col-sm-8" @click="linkcontract(item.contractUrl)">
                <p class="form-control-plaintext link f12">{{ item.contractCode | checkEmpty }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái yêu cầu gốc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <span class="badge" :class="item.state">
                  {{ item.state | transfromMccName(configInfoChange.stateChangeOverview) }}
                </span>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái MC xác nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <span class="badge bg-primary text-white" :class="item.confirmState">
                  {{ item.confirmState | transformData(confirmStateOptions) }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>2. Thông tin thay đổi</h1>
            <p v-if="item.is360Req && item.is360Req === true">Nguồn yêu cầu: <b>MPOS360</b></p>
            <div v-for="(item, index) in item.groupChangeInfos" :key="index">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th class="head" scope="col"><b>Nhóm yêu cầu</b></th>
                    <th class="head" scope="col"><b>Thời gian</b></th>
                    <th class="head" scope="col"><b>Phụ lục đính kèm</b></th>
                    <!-- <th class="head" scope="col"><b>Thao tác</b></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row">
                    <td class="body">
                      <span>{{ item.groupCode }}</span>
                    </td>
                    <td class="body">
                      <span>
                        <p>Ký:{{ item.appendixSignDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                      </span>
                    </td>
                    <td class="body">
                      <span>
                        <p>Mã phụ lục: {{ item.appendixCode }}</p>
                        <p>
                          Trạng thái phụ lục:
                          {{ item.appendixState | transformData(Config.listStatusContract) }}
                        </p>
                        <div v-if="item?.arrDocLosts && item?.arrDocLosts?.length > 0">
                          Thông tin thêm:
                          <p v-for="(docsList, index) in item.arrDocLosts" :key="index">
                            - {{ getMapDocLost(docsList) }}
                          </p>
                        </div>
                      </span>
                    </td>
                    <!-- <td class="text-center body">
                      <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    class="dropdown-item"
                    @click="approve(item.appendixId)"
                    v-if="dataPermission.includes('SCON_IN4CHANGE_APPROVE')"
                    ><span>&nbsp;</span>Duyệt
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    @click="reject(item.appendixId)"
                    v-if="dataPermission.includes('SCON_IN4CHANGE_REJECT')"
                    ><span>&nbsp;</span>Từ chối
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    @click="additional(item.appendixId)"
                    v-if="dataPermission.includes('SCON_IN4CHANGE_ADDITIONAL')"
                    ><span>&nbsp;</span>Cần bổ sung
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    @click="openAdditionalFile(item.appendixId)"
                    ><span>&nbsp;</span>Bổ sung hồ sơ
                  </b-dropdown-item>
                </b-dropdown>
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <div
                style="
                  text-align: center;
                  margin-bottom: 5px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div>
                  <b-button
                    class="ml-2"
                    pill
                    variant="primary"
                    v-if="dataPermission.includes('SCON_IN4CHANGE_APPROVE')"
                    @click="approve(item.appendixId)"
                    >Duyệt</b-button
                  >
                  <b-button
                    class="ml-2"
                    pill
                    variant="warning"
                    @click="additional(item.appendixId)"
                    v-if="dataPermission.includes('SCON_IN4CHANGE_ADDITIONAL')"
                    >Cần bổ sung</b-button
                  >

                  <b-button
                    class="ml-2"
                    pill
                    variant="success"
                    @click="openAdditionalFile(item.appendixId)"
                    >Bổ sung hồ sơ</b-button
                  >
                </div>
                <b-button
                  class="ml-2"
                  pill
                  variant="outline-danger"
                  @click="reject(item.appendixId)"
                  v-if="dataPermission.includes('SCON_IN4CHANGE_REJECT')"
                  >Từ chối</b-button
                >
              </div>
              <div class="form-detail" v-for="(value, index) in item.subChangeInfos" :key="index">
                <div class="form-row title">
                  <div class="col-sm-6">
                    <p>
                      <b
                        >Tên yêu cầu {{ index + 1 }}:
                        {{
                          value.typeChange | transfromMccName(configInfoChange.typeChangeInfo)
                        }}</b
                      >
                    </p>
                    <p>Tạo: {{ value.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                  </div>
                  <div class="col-sm-6 title-status">
                    <span class="badge fs-14" :class="value.state">
                      {{ value.state | transfromMccName(configInfoChange.stateChangeDetailInfo) }}
                    </span>
                  </div>
                </div>
                <table class="w-100 mb-2">
                  <thead class="thead-gray">
                    <tr>
                      <th class="head" scope="col"><b>Tên thông tin</b></th>
                      <th class="head" scope="col"><b>Thông tin cũ</b></th>
                      <th class="head" scope="col"><b>Thông tin mới</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-if="value.representName">
                      <td class="text-center body">Tên người đại diện</td>
                      <td class="text-center body">
                        {{ value.representName.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.representName.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('representName', value.representName.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.representPosition">
                      <td class="text-center body">Chức vụ</td>
                      <td class="text-center body"></td>
                      <td class="text-center body">{{ value.representPosition | checkEmpty }}</td>
                    </tr>
                    <tr class="table-row" v-if="value.representMobile">
                      <td class="text-center body">Số điện thoại</td>
                      <td class="text-center body">
                        {{ value.representMobile.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.representMobile.newData | checkEmpty }}
                        <span
                          v-if="checkVerifyInfo('representMobile', value.representMobile.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.representEmail">
                      <td class="text-center body">Email</td>
                      <td class="text-center body">
                        {{ value.representEmail.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.representEmail.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('representEmail', value.representEmail.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.representPassport">
                      <td class="text-center body">Số CCCD/ Hộ chiếu</td>
                      <td class="text-center body">
                        {{ value.representPassport.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.representPassport.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo('representPassport', value.representPassport.newData)
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.representPermanentAddress">
                      <td class="text-center body">Địa chỉ thường chú</td>
                      <td class="text-center body">
                        {{ value.representPermanentAddress.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.representPermanentAddress.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo(
                              'representPermanentAddress',
                              value.representPermanentAddress.newData
                            )
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.representCurrentAddress">
                      <td class="text-center body">Địa chỉ hiện tại</td>
                      <td class="text-center body">
                        {{ value.representCurrentAddress.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.representCurrentAddress.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo(
                              'representCurrentAddress',
                              value.representCurrentAddress.newData
                            )
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.representAuthContractNumber">
                      <td class="text-center body">Số giấy ủy quyền</td>
                      <td class="text-center body"></td>
                      <td class="text-center body">
                        {{ value.representAuthContractNumber | checkEmpty }}
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessAuthoriserName">
                      <td class="text-center body">Họ Và Tên</td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserName.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserName.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo(
                              'businessAuthoriserName',
                              value.businessAuthoriserName.newData
                            )
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessAuthoriserMobile">
                      <td class="text-center body">Số Điện Thoại</td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserMobile.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserMobile.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo(
                              'businessAuthoriserMobile',
                              value.businessAuthoriserMobile.newData
                            )
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessAuthoriserEmail">
                      <td class="text-center body">Email</td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserEmail.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserEmail.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo(
                              'businessAuthoriserEmail',
                              value.businessAuthoriserEmail.newData
                            )
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessPosition">
                      <td class="text-center body">Chức Danh</td>
                      <td class="text-center body">
                        {{ value.businessPosition.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessPosition.newData | checkEmpty }}
                        <span
                          v-if="checkVerifyInfo('businessPosition', value.businessPosition.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessAuthoriserPassport">
                      <td class="text-center body">CCCD</td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserPassport.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessAuthoriserPassport.newData | checkEmpty }}
                        <span
                          v-if="
                            checkVerifyInfo(
                              'businessAuthoriserPassport',
                              value.businessAuthoriserPassport.newData
                            )
                          "
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessMcName">
                      <td class="text-center body">Tên Doanh nghiệp/HKD</td>
                      <td class="text-center body">
                        {{ value.businessMcName.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessMcName.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('businessMcName', value.businessMcName.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessAddress">
                      <td class="text-center body">Địa chỉ trụ sở</td>
                      <td class="text-center body">
                        {{ value.businessAddress.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessAddress.newData | checkEmpty }}
                        <span
                          v-if="checkVerifyInfo('businessAddress', value.businessAddress.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessCity">
                      <td class="text-center body">Tỉnh/Thành phố</td>
                      <td class="text-center body">
                        {{ value.businessCity.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessCity.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('businessCity', value.businessCity.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessDistrict">
                      <td class="text-center body">Quận/Huyện</td>
                      <td class="text-center body">
                        {{ value.businessDistrict.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessDistrict.newData | checkEmpty }}
                        <span
                          v-if="checkVerifyInfo('businessDistrict', value.businessDistrict.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.businessWard">
                      <td class="text-center body">Phường/Xã</td>
                      <td class="text-center body">
                        {{ value.businessWard.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.businessWard.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('businessWard', value.businessWard.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.bankAccType">
                      <td class="text-center body">Loại tài khoản ngân hàng</td>
                      <td class="text-center body">
                        {{
                          value.bankAccType.oldData
                            | transfromMccName(configInfoChange.mcBankAccType)
                        }}
                      </td>
                      <td class="text-center body">
                        {{
                          value.bankAccType.newData
                            | transfromMccName(configInfoChange.mcBankAccType)
                        }}
                        <span v-if="checkVerifyInfo('bankAccType', value.bankAccType.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.holderName">
                      <td class="text-center body">Tên chủ tài khoản</td>
                      <td class="text-center body">{{ value.holderName.oldData | checkEmpty }}</td>
                      <td class="text-center body">
                        {{ value.holderName.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('holderName', value.holderName.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.accountNo">
                      <td class="text-center body">Số TKNH</td>
                      <td class="text-center body">{{ value.accountNo.oldData | checkEmpty }}</td>
                      <td class="text-center body">
                        {{ value.accountNo.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('accountNo', value.accountNo.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.bankName">
                      <td class="text-center body">Ngân hàng</td>
                      <td class="text-center body">{{ value.bankName.oldData | checkEmpty }}</td>
                      <td class="text-center body">
                        {{ value.bankName.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('bankName', value.bankName.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.branch">
                      <td class="text-center body">Chi nhánh</td>
                      <td class="text-center body">{{ value.branch.oldData | checkEmpty }}</td>
                      <td class="text-center body">
                        {{ value.branch.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('branch', value.branch.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.bankCityName">
                      <td class="text-center body">Tỉnh/Thành phố</td>
                      <td class="text-center body">
                        {{ value.bankCityName.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.bankCityName.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('bankCityName', value.bankCityName.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.accountEmail">
                      <td class="text-center body">Email</td>
                      <td class="text-center body">
                        {{ value.accountEmail.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.accountEmail.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('accountEmail', value.accountEmail.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                    <tr class="table-row" v-if="value.accountMobile">
                      <td class="text-center body">Số điện thoại</td>
                      <td class="text-center body">
                        {{ value.accountMobile.oldData | checkEmpty }}
                      </td>
                      <td class="text-center body">
                        {{ value.accountMobile.newData | checkEmpty }}
                        <span v-if="checkVerifyInfo('accountMobile', value.accountMobile.newData)"
                          ><b-icon icon="check-square" scale="2" variant="success"></b-icon
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                  <div v-if="value.representMutualRelation" class="form-style2">
                    <p>
                      Mối quan hệ giữa Người đại diện hiện tại và Người đại diện mới:
                      {{ value.representMutualRelation }}
                    </p>
                  </div>
                  <div v-if="value.bankMutualRelation" class="form-style2">
                    <p>Mối quan hệ giữa hai Bên thụ hưởng là: {{ value.bankMutualRelation }}</p>
                  </div>
                  <div v-if="value.bankMutualRelation" class="form-style2">
                    <p>
                      Vai trò/Vị trí của Người được ủy quyền nhận tiền mới là:
                      {{ value.positionAuthBank }}
                    </p>
                  </div>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>HỒ SƠ/ CHỨNG TỪ ĐÍNH KÈM</h1>
            <UploadMultiple
              v-if="image.passportRepresent"
              :lsData="image.passportRepresent"
              :canUpload="false"
              uniqueKey="images"
              title="CCCD/CMND của người đại diện"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="image.passportAuthoriser"
              :lsData="image.passportAuthoriser"
              :canUpload="false"
              uniqueKey="images"
              title="CCCD/CMND của người được ủy quyền"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="item.substituteCertUrls"
              :lsData="item.substituteCertUrls"
              :canUpload="false"
              uniqueKey="images"
              title="Chứng từ thay thế"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="item.authorizationUrls"
              :lsData="item.authorizationUrls"
              :canUpload="false"
              uniqueKey="images"
              title="Ảnh giấy ủy quyền"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="item.lostPassportUrls"
              :lsData="item.lostPassportUrls"
              :canUpload="false"
              uniqueKey="images"
              title="Chứng từ thay thế trong trường hợp không có CCCD/CMND (Ảnh chụp của giấy phép lái xe/ sổ hộ khẩu/ hộ chiếu)"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="item.attachedCertUrls"
              :lsData="item.attachedCertUrls"
              :canUpload="false"
              uniqueKey="images"
              title="Chứng từ đính kèm (Giấy đăng ký kết hôn, Giấy khai sinh, Sổ hộ khẩu, Giấy xác nhận công chứng tại địa phương/ Giấy ủy quyền ...)"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="item.lostEmailUrls"
              :lsData="item.lostEmailUrls"
              :canUpload="false"
              uniqueKey="images"
              title="Ảnh chụp hoặc video Merchant đang cầm CMND và phụ lục"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              v-if="item.additionalUrls"
              :lsData="item.additionalUrls"
              :canUpload="false"
              uniqueKey="images"
              title="Hồ sơ bổ sung thêm"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <div class="img-list" v-if="urlPdf">
              <ul class="m-0">
                <h6>File phụ lục</h6>
                <li>
                  <a target="_blank" :href="urlWithFile(url(urlPdf) || urlPdf)">
                    <img src="@/assets/img/file.jpg" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-detail">
            <h1>Lịch sử</h1>
            <div class="table-responsive text-center p-0">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col"><b>Số yêu cầu</b></th>
                    <th scope="col"><b>Người tại yêu cầu</b></th>
                    <th scope="col"><b>Ngày ký biên bản</b></th>
                    <th scope="col"><b>Người thực hiện thao tác</b></th>
                    <th scope="col"><b>Thời gian thực hiện thao tác</b></th>
                    <th scope="col"><b>Tên thao tác</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(data, index) in historyInfoChange" :key="index">
                    <td class="text-center">{{ data.subChangeInfoCode | checkEmpty }}</td>
                    <td class="text-center">{{ data.createReqBy | checkEmpty }}</td>
                    <td class="text-center">
                      {{ data.signDate | formatDate('HH:mm, DD/MM/YYYY') }}
                    </td>
                    <td class="text-center">{{ data.executor | checkEmpty }}</td>
                    <td class="text-center">
                      {{ data.execDate | formatDate('HH:mm, DD/MM/YYYY') }}
                    </td>
                    <td class="text-center">
                      <p>{{ data.action }}</p>
                      <p>{{ data.desc }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>

    <!-- //modal  -->
    <b-modal
      centered
      id="additionalFile"
      modal-class="overflow-hidden"
      static
      scrollable
      v-if="canOpenAdditionalFile"
    >
      <!-- @hidden="onHidden" -->
      <template #modal-header="{ close }">
        <h5>Bổ sung giấy tờ</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div>
        <div class="form-group">
          <div class="text-center mb-3">
            <span>Bạn vui lòng bổ sung thêm giấy tờ còn thiếu tại đây</span>
          </div>
          <div v-for="(file, index) in uploadedFiles" :key="index" class="down-linkfile">
            <img src="@/assets/img/file-pdf.svg" class="me-2" />
            {{ file.name }}
            <button type="button" class="btn-delete" @click="removeFile(index)">
              <img src="@/assets/img/close-img.svg" />
            </button>
          </div>

          <div class="take-photo w-100 d-block" @click="triggerFileInput()">
            <div class="item text-center">
              <img src="@/assets/img/ic-download.svg" />
              <span class="BE-bold">Tải tệp lên</span>
            </div>
          </div>
          <input
            type="file"
            ref="documentFileInput"
            accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp,image/*"
            multiple
            class="hidden-input"
            @change="handleDocumentUpload"
          />
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
        <b-button size="sm" variant="primary" @click="uploadDocument"> Xác nhận </b-button>
      </template>
    </b-modal>
    <StatusChangeModal
      modal-id="statusChangeModal"
      :req-id="$route.params.id"
      @confirm="handleStatusChange"
    />
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import { ContractService } from '@/services/contract.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import StatusChangeModal from './StatusChangeModal.vue'

  export default {
    name: 'detail-info-change',
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        Config,
        item: {},
        showLoading: false,
        configInfoChange: {},
        historyInfoChange: [],
        uploadedFiles: [],
        image: {},
        appendixId: '',
        canOpenAdditionalFile: false,
        verifyInfoRes: {},
        confirmStateOptions: [
          { id: 'ALL', text: 'Tất cả' },
          { id: 'UNKNOWN', text: 'Không xác định' },
          { id: 'WAITING', text: 'Chờ MC xác nhận' },
          { id: 'CONFIRMED', text: 'MC đã xác nhận' },
        ],
      }
    },
    components: { UploadMultiple, StatusChangeModal },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      checkVerifyInfo() {
        return (key, value) => {
          if (!key || !value) return false
          if (this.verifyInfoRes[key] && this.verifyInfoRes[key].includes(value)) return true

          return false
        }
      },
    },
    async created() {
      try {
        this.showLoading = true
        await this.fetchData()
        await this.fetchHistory()
        this.getConfigInfoChange()
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      getMapDocLost(code) {
        const target = this.configInfoChange?.documentLost?.find(x => x.code === code)
        if (target) return target.name
        return code
      },
      openStatusChangeModal() {
        this.$bvModal.show('statusChangeModal')
      },

      async handleStatusChange(data) {
        try {
          this.showLoading = true
          // Gọi API với data.reqId và data.status
          const res = await ContractService.changeStatus(data)
          if (res.code === 1000) {
            this.fetchData()
            this.showSuccessMx('Chuyển trạng thái thành công')
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      async fetchHistory() {
        try {
          const response = await ContractService.fetchHistoryInfoChange({
            reqId: this.$route.params.id,
          })
          this.historyInfoChange = response.data.data
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          this.showLoading = true
          const res = await ContractService.detailInfoChange({ reqId: this.$route.params.id })
          this.item = res.data.data
          this.image = {
            passportRepresent: [
              res.data.data.passportRepresentFrontUrl,
              res.data.data.passportRepresentBackUrl,
            ],
            passportAuthoriser: [
              res.data.data.passportAuthoriserFrontUrl,
              res.data.data.passportAuthoriserBackUrl,
            ],
          }
          this.urlPdf = res.data.data.groupChangeInfos[0].urlPdf
          this.verifyInfoRes = (this.item.verifyInfoRes || []).reduce((acc, current) => {
            if (!acc[current.key]) acc[current.key] = []

            acc[current.key] = current.values

            return acc
          }, {})
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      linkcontract(link) {
        window.open(link, '_blank')
      },
      linkMC(id) {
        window.open(`/list-mc/${id}`, '_blank')
      },
      getConfigInfoChange() {
        return CommonService.getConfigInfoChange()
          .then(data => {
            if (data.success) {
              this.configInfoChange = data.data
            }
          })
          .catch(error => console.log(error))
      },
      async approve(appendixId) {
        try {
          const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
          if (flag !== true) return
          this.showLoading = true
          const res = await ContractService.approveInfoChange({ appendixId })
          if (res.code === 1000) {
            this.fetchData()
            this.showSuccessMx('Duyệt thành công')
          } else this.showFailMx(res.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      async reject(appendixId) {
        try {
          const { value: flag, note } = await this.rejectMx()
          if (flag !== true) return
          this.showLoading = true
          const params = {
            appendixId,
            reason: note,
          }
          const res = await ContractService.rejectInfoChange(params)
          if (res.code === 1000) {
            this.fetchData()
            this.showSuccessMx('Từ chối thành công')
          } else this.showFailMx(res.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      async additional(appendixId) {
        try {
          const { value: flag, note } = await this.rejectMx('Lý do cần bổ sung')
          if (flag !== true) return
          this.showLoading = true
          const params = {
            appendixId,
            reason: note,
          }
          const res = await ContractService.additionalChange(params)
          if (res.code === 1000) {
            this.fetchData()
            this.showSuccessMx('YC bổ sung thành công')
          } else this.showFailMx(res.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      openAdditionalFile(appendixId) {
        this.canOpenAdditionalFile = true
        this.appendixId = appendixId
        this.$nextTick(() => this.$bvModal.show('additionalFile'))
      },
      async uploadDocument() {
        try {
          this.showLoading = true
          for (const file of this.uploadedFiles) {
            const responseUrl = await this.sendDocument(file)
            if (responseUrl) {
              this.additionalFile(responseUrl)
            }
          }
        } catch (error) {
          console.log('Error uploading files:', error)
        } finally {
          this.showLoading = false
        }
      },
      async sendDocument(file) {
        if (file) {
          const formData = new FormData()
          formData.append('files', file)
          formData.append('folderName', 'NextCrm')

          // Kiểm tra xem file có phải là ảnh không
          const isImage = file.type.startsWith('image/')

          // Gọi API tương ứng
          const response = isImage
            ? await CommonService.uploadImg(formData)
            : await CommonService.uploadFile(formData)

          if (response.code === 1000) {
            const urlFile = response.data
            return urlFile
          } else {
            this.showFailMx(response.message)
          }
        } else {
          return null
        }
      },
      triggerFileInput() {
        this.$refs.documentFileInput.click()
      },
      removeFile(index) {
        this.uploadedFiles.splice(index, 1)
      },
      handleDocumentUpload(event) {
        const files = Array.from(event.target.files)
        this.uploadedFiles.push(...files)
        this.$refs.documentFileInput.value = ''
      },
      async additionalFile(file) {
        try {
          const params = {
            appendixId: this.appendixId,
            additionalUrls: file,
          }
          const res = await ContractService.additionalFile(params)
          if (res.code === 1000) {
            this.showSuccessMx('Bổ sung hồ sơ thành công')
            this.canOpenAdditionalFile = false
          } else this.showFailMx(res.message)
        } catch (error) {
          console.log(error)
        }
      },
      urlWithFile(filename) {
        var pattern = /\.pdf|doc|docx$/i
        if (pattern.test(filename)) return '/viewer/pdf?url=' + filename
        else return filename
      },
      url(item) {
        return item?.[this.keyUrl]
      },
    },
  }
</script>
<style scoped>
  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .link {
    cursor: pointer;
    color: blue;
  }

  .text-start {
    text-align: start;
    padding-left: 3px;
  }

  h6 {
    font-weight: 600;
    font-size: 14px;
  }

  .breadcrumb-area {
    display: flex;
    justify-content: space-between;
  }

  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }

  .WAITING_PROCESS {
    color: #fff;
    background-color: #c7c42c;
  }

  .CHANGE_BANK_ACCOUN_INFO {
    color: #fff;
    background-color: #ec38d4;
  }

  .CHANGE_REPRESENT_INFO {
    color: #fff;
    background-color: #13bbd1;
  }

  .b-table-sticky-header {
    min-height: 110px !important;
  }

  .head {
    padding: 7px;
    text-align: center;
  }

  .body {
    padding: 7px;
  }

  .title {
    padding: 5px;
    background: #dee2e6;
    margin: 0px;
  }

  .title-status {
    text-align: center;
    margin: auto;
  }

  .fs-14 {
    font-size: 14px;
  }

  .take-photo .item {
    border: 2px dashed #008bf4;
    background: #e6f4fe;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 16px 5px;
    border-radius: 12px;
  }

  .take-photo .item img {
    display: block;
    margin-bottom: 10px;
  }

  .hidden-input {
    display: none;
  }

  .down-linkfile:last-child {
    margin-bottom: 0;
  }

  .down-linkfile {
    border: 1px solid #ebebeb;
    border-radius: 12px;
    padding: 12px;
    display: block;
    margin-bottom: 12px;
    font-size: 14px;
    color: #404041 !important;
    position: relative;
  }

  .down-linkfile .btn-delete {
    top: 8px;
    right: 8px;
  }

  .btn-delete {
    background: none;
    border: none;
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
  }

  .btn-delete:focus {
    border: none;
  }

  .btn-delete img {
    height: auto;
  }
</style>
